import React, { createContext, useContext } from 'react';
import propTypes from 'prop-types';
import useTestPlaybookDrawer from './useTestPlaybookDrawer';

const TestPlaybookDrawerContext = createContext(null);

export default function TestPlaybookDrawerContextProvider({ integration, playbookState, mode, setMode, children }) {
  const value = useTestPlaybookDrawer({ integration, playbookState, mode, setMode });
  return <TestPlaybookDrawerContext.Provider value={value}>{children}</TestPlaybookDrawerContext.Provider>;
}

export function useTestPlaybookDrawerContext() {
  return useContext(TestPlaybookDrawerContext);
}

TestPlaybookDrawerContextProvider.propTypes = {
  integration: propTypes.object.isRequired,
  playbookState: propTypes.object.isRequired,
  mode: propTypes.string.isRequired,
  setMode: propTypes.func.isRequired,
  children: propTypes.node.isRequired,
};
